import { Column, Entity, PrimaryColumn } from "typeorm";
import { Tags } from "../../_objects/tags";
import { TenantIdSchemaBase } from "../interfaces/tenantId.base";

/**
 * TagSchema インターフェイス。
 */
export interface ITagsSchema {
  tenantId: string;
  id: string;
  items: string;
  isDeleted: boolean;
  isValid: boolean;
  createDate: string;
  createdBy: string;
  lastUpdateDate: string;
  lastUpdatedBy: string;
  schemaVersion: string;
}

@Entity()
export class TagsSchema implements TenantIdSchemaBase, ITagsSchema {
  @PrimaryColumn()
  tenantId: string;

  @Column({ nullable: true })
  id: string | null;

  @Column({ nullable: true })
  items: string | null;

  @Column({ nullable: true })
  isDeleted: boolean | null;

  @Column({ nullable: true })
  isValid: boolean | null;

  @Column({ nullable: true })
  createDate: string | null;

  @Column({ nullable: true })
  createdBy: string | null;

  @Column({ nullable: true })
  lastUpdateDate: string | null;

  @Column({ nullable: true })
  lastUpdatedBy: string | null;

  @Column({ nullable: true })
  schemaVersion: string | null;

  constructor(tenantId: string, tags?: Tags) {
    if (tags) {
      this.tenantId = tenantId;
      this.id = tags.id;
      this.items = tags.items ? JSON.stringify(tags.items) : null;
      this.isDeleted = tags.isDeleted;
      this.isValid = tags.isValid;
      this.createDate = tags.createDate;
      this.createdBy = tags.createdBy;
      this.lastUpdateDate = tags.lastUpdateDate;
      this.lastUpdatedBy = tags.lastUpdatedBy;
      this.schemaVersion = tags.schemaVersion;
    }
  }
}
